import { FormDividingLineComponent } from 'src/features/generalForms/builder/types/DividingLine';
import { RPDF } from 'src/features/report/react-pdf';
import { ReportColors } from 'src/features/report/report-colors';

export const FormDividingLine: FormDividingLineComponent = () => {
  return (
    <RPDF.View style={[RPDF.tableStyles.divider, { marginVertical: 10, borderBottomColor: ReportColors.plain }]} />
  );
};
